
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite_agent",
      function () {
        return require("private-next-pages/invite_agent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite_agent"])
      });
    }
  